import React from 'react'
import Fade from 'react-reveal/Fade'

import useLatestPosts from "../hooks/use-latest-posts"

import ArticleCard from './cards/article'

const LatestArticles = ({ title = 'Latest News & Articles', style = 'light' }) => {
  // Data
  const posts = useLatestPosts()

  return (
    <>
      <section className={`latest-articles ${style ? 'latest-articles--dark' : ''}`}>
        <div className='latest-articles__inner'>
          <Fade bottom distance={'40px'}>
            <div className='latest-articles__header'>
              {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
            </div>
            <div className='latest-articles__list'>
              {posts?.map((el) => (<ArticleCard key={el.id} {...el} />))}
            </div>
          </Fade>
        </div>
      </section>
    </>
  )
}

export default LatestArticles 